import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53bd4e2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prompt-settings" }
const _hoisted_2 = { class: "prompt-settings__item" }
const _hoisted_3 = { class: "prompt-settings__item__title" }
const _hoisted_4 = { class: "prompt-settings__info d-flex" }
const _hoisted_5 = { class: "prompt-settings__info__title" }
const _hoisted_6 = { class: "prompt-settings__info__text" }
const _hoisted_7 = { class: "prompt-settings__info__text__item" }
const _hoisted_8 = { class: "prompt-settings__info__text__item" }
const _hoisted_9 = { class: "prompt-settings__info__text__item" }
const _hoisted_10 = { class: "prompt-settings__info__example" }
const _hoisted_11 = { class: "prompt-settings__info__example__title" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "prompt-settings__item" }
const _hoisted_14 = { class: "prompt-settings__item__title" }
const _hoisted_15 = { class: "negative-items" }

import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';

import i18n from '@/plugins/i18n';
import { useEditorStore } from '@/store/editor';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromptSettings',
  setup(__props) {

const { generateImageData } = storeToRefs(useEditorStore());
const negative = ref<string>('');
const lang = computed(() => i18n.global.locale.value);

const addNegative = (): void => {
  if (negative.value.length === 0 || (negative.value.startsWith('\n') && negative.value.length === 1)) {
    negative.value = '';
    return;
  }
  generateImageData.value.negativeList.push(negative.value.replace(/[\s.,;:%]/g, ''));
  negative.value = '';
};

const removeFromNegative = (key: number): void => {
  generateImageData.value.negativeList.splice(key, 1);
};

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('editor.settings.bg-description')), 1),
      _createVNode(_component_v_textarea, {
        modelValue: _unref(generateImageData).prompt,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(generateImageData).prompt) = $event)),
        class: "prompt-settings__item__textarea prompt-settings__item__textarea--prompt",
        placeholder: _ctx.$t('editor.settings.prompt-placeholder'),
        "hide-details": "auto"
      }, null, 8, ["modelValue", "placeholder"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_spacer),
        _createVNode(AiTooltip, {
          "tooltip-text": _ctx.$t('editor.settings.prompt-info-tooltip'),
          location: "bottom",
          "content-class": "prompt-settings__info__content"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('editor.settings.prompt-info-title')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('editor.settings.prompt-info-step-1')), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('editor.settings.prompt-info-step-2')), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('editor.settings.prompt-info-step-3')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('editor.settings.prompt-info-example-title')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('editor.settings.prompt-info-example-text')), 1)
            ]),
            _createElementVNode("a", {
              href: 
              lang.value === 'ru' ? 'https://24ai.tech/blog/how-to-use-24ai/' : 'https://24ai.tech/en/blog/how-to-use-24ai/'
            ,
              target: "_blank",
              class: "prompt-settings__info__link"
            }, _toDisplayString(_ctx.$t('editor.settings.prompt-info-link')), 9, _hoisted_12)
          ]),
          _: 1
        }, 8, ["tooltip-text"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('editor.settings.negative')), 1),
      _createVNode(_component_v_textarea, {
        modelValue: negative.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((negative).value = $event)),
        modelModifiers: { trim: true },
        onKeydown: _withKeys(_withModifiers(addNegative, ["prevent"]), ["enter","space"]),
        onBlur: addNegative,
        class: "prompt-settings__item__textarea prompt-settings__item__textarea--negative",
        placeholder: _ctx.$t('editor.settings.negative-placeholder'),
        "hide-details": "auto"
      }, null, 8, ["modelValue", "onKeydown", "placeholder"]),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(generateImageData).negativeList, (item, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "negative-item",
            key: 'negative-list' + key
          }, [
            _createTextVNode(_toDisplayString(item) + " ", 1),
            _createVNode(AiClearButton, {
              icon: "",
              class: "negative-item__button",
              onClick: ($event: any) => (removeFromNegative(key))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_inline_svg, {
                  src: require('@/assets/icons/editor/negative-remove.svg')
                }, null, 8, ["src"])
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})